/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Control_Track_Fade_LabelInputs */



/**
* | output |
* | --- |
* | "Programme fade (dB)" |
*
* @param {Audio_Description_Export_Control_Track_Fade_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_control_track_fade_label = /** @type {((inputs?: Audio_Description_Export_Control_Track_Fade_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Control_Track_Fade_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Atténuation du programme (dB)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programmabsenkung (dB)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attenuazione programma (dB)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приглушение программы (дБ)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atenuación del programa (dB)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节目音频衰减（dB）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("番組音声のフェード量（dB）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोग्राम फ़ेड (dB)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atenuação do programa (dB)")
	return /** @type {LocalizedString} */ ("Programme fade (dB)")
});